import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=85a28624&"
import script from "./NotificationBell.vue?vue&type=script&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports